<template>
  <div>
    <page-title
      heading="Daftar Pasien"
      :breadcrumb="[
        {
          label: 'Daftar Pasien',
          link: '/pasien'
        },
        {
          label: 'Tambah Pasien',
          active: true
        }
      ]"
    />

    <div class="container-fluid">
      <div class="card card-box">
        <div class="card-header"  style="background-color : #d3e8eb">
          <h4 class="text-capitalize my-2">tambah pasien</h4>
        </div>
        <div class="card-body">
          <PasienForm @keluar="goingPlaces" @submitForm="submitForm" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import startCase from "lodash/startCase";
import pasienMixin from "./mixins";
import moment from "moment";
moment.locale('id');

export default {
  mixins: [pasienMixin],
  components: {
    PasienForm: () => import("./PasienForm")
  },
  data: () => ({
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      maxFilesize: 0.5,
      headers: { "My-Awesome-Header": "header value" }
    },
    beingSubmit: false,
    cekRekamMedis : '',
  }),
  mounted() {
    // this.cekPaket();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem('IDLE') != 1) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          localStorage.removeItem('is_antrean');
          next();
        } else {
          next(false);
        }
      });
    } else {
      localStorage.removeItem('is_antrean');
      next();
    }
  },
  methods: {
    simpan(nama_pasien, nomor_rekam_medis, isAddAntrean) {
      this.$swal({
        title: startCase("data berhasil disimpan"),
        text: `Pasien atas nama '${nama_pasien}' tersimpan dengan nomor rekam medis ${nomor_rekam_medis}`,
        type: "success"
      });
    },
    submitForm(data) {
      this.beingSubmit = true;
      this.addPasien(data);
    },
    goingPlaces(nama_pasien, nomor_rekam_medis, isAddAntrean ) {
      if (this.beingSubmit) {
        if(!isAddAntrean){
          const tmp = {
            name: "pasien-list"
          };
          tmp.onComplete = this.simpan(nama_pasien, nomor_rekam_medis);
          this.$router.push(tmp);
        } else {
          const tmp = {
            name: "registrasi-rawat-jalan",
            query: { isAddAntrean: true } 
          };
          tmp.onComplete = this.simpan(nama_pasien, nomor_rekam_medis);
          // console.log('dari pasien', tmp)
          this.$router.push(tmp);
        }
      }
    },
    beforeAddPasien(postData) {
      // sementara untuk demo nomor rekam medis di buat urutan dulu
      postData.klinik_id = this.$store.state.user.klinik_id;
      axios.get(`${this.url_api}/pasien`).then(res => {
        let totalCurrentPasien = res.data.data.pasien.total;
        postData.nomor_rekam_medis = 100000 + (totalCurrentPasien + 1);
        this.cekRekamMedis = postData.nomor_rekam_medis;
        this.addPasien(postData);
      });
    },
    async addPasien(postData) {
      try {
        const res = await axios.post(
          `${this.url_api}/pasien`,
          this.mapPasienFormData(postData)
        );
        console.log(this.mapPasienFormData(postData))
        const {
          success,
          data: { nama, nomor_rekam_medis }
        } = res.data;
        if (success) {
          this.goingPlaces(nama, nomor_rekam_medis, postData.addToAntrean);
        }
      } catch (err) {
        if (err.response) {
          const { message } = err.response.data;
          this.$swal({
            text: `${message || "something went wrong"}`,
            type: "error"
          });
        }
        console.log(err);
      } finally {
        this.beingSubmit = false;
      }
    }
  }
};
</script>
<style lang="scss">
.custom-dropzone {
  .dz-message {
    padding: 10rem 1rem;
  }
}
</style>
